import { render } from "./JoinManufacturer.vue?vue&type=template&id=78f1a576"
import script from "./JoinManufacturer.vue?vue&type=script&lang=js"
export * from "./JoinManufacturer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__